export const mapGovernoratesToUi = (data) => {
    const governorates = [];
    if (data) {
        const keys = Object.keys(data);
        keys.forEach((key) => {
            governorates.push({ value: data[key].id, label: data[key].attributes.nameAr });
        });
    }

    return governorates;
};


export const mapOrganizationsToUi = (data) => {
    const governorates = [];
    if (data) {
        const keys = Object.keys(data);
        keys.forEach((key) => {
            governorates.push({ value: data[key].id, label: data[key].attributes.name });
        });
    }

    return governorates;
};
export const mapSupplierByIdToUi = (supplierData, paymentMethodData) => ({
    arabicName: supplierData.name,
    phoneNumber: supplierData.phoneNumber,
    email: supplierData.email,
    nationalId: supplierData.nationalId,
    nationalIdFace: null,
    nationalIdBack: null,
    supplierPictureAttachments: null,
    paymentMethodDelete: false,
    supplierType: {
        value: supplierData.supplierType,
        label: supplierData.supplierType,
    },
    truckTypes: supplierData?.truckTypes?.map((item) => ({ value: item, label: item })),
    workingGovernorates: supplierData?.workingGovernorates?.map((item) => ({
        value: item?.id,
        label: item?.name,
    })),
    hasACompany:
        supplierData.hasACompany === true
            ? {
                value: supplierData.hasACompany,
                label: "Yes",
            }
            : {
                value: supplierData.hasACompany,
                label: "No",
            },
    companyName: supplierData?.companyName,
    commercialRegistrationAttachments: null,
    taxCardAttachments: null,
    paymentMethod: {
        label: paymentMethodData?.[0]?.attributes?.methodType,
        value: paymentMethodData?.[0]?.attributes?.methodType,
    },
    bankName: {
        value: paymentMethodData?.[0]?.attributes?.bankName,
        label: paymentMethodData?.[0]?.attributes?.bankName,
    },
    bankAccountNumber: paymentMethodData?.[0]?.attributes?.bankAccountNumber,
    ibanNumber: paymentMethodData?.[0]?.attributes?.bankIban,
    eWalletName: {
        value: paymentMethodData?.[0]?.attributes?.eWalletType,
        label: paymentMethodData?.[0]?.attributes?.eWalletType,
    },
    eWalletNumber: paymentMethodData?.[0]?.attributes?.eWalletNumber,
    mezzaCardName: {
        value: paymentMethodData?.[0]?.attributes?.mezzaCardType,
        label: paymentMethodData?.[0]?.attributes?.mezzaCardType,
    },
    meezaCardNumber: paymentMethodData?.[0]?.attributes?.mezzaCardNumber,
    accountHolderName: paymentMethodData?.[0]?.attributes?.accountHolderName,
    organizationId: supplierData.organizationId,
});
